export const INTEGRATION_ITEM_EDITABLE_FIELDS = [
  'teamId',
  'estimationId',
  'plannedStartDateTime',
  'plannedFinishDateTime',
  'itemStatusId',
] as const;

export type IntegrationItemEditableField = (typeof INTEGRATION_ITEM_EDITABLE_FIELDS)[number];

export function isIntegrationItemEditableField(
  field: string,
): field is IntegrationItemEditableField {
  return (INTEGRATION_ITEM_EDITABLE_FIELDS as readonly string[]).includes(field);
}

export function isItemEditable(
  externalKey: string | null | undefined,
  integrationItemsEditable: boolean,
): boolean {
  if (externalKey && !integrationItemsEditable) return false;
  return true;
}
